import{ens_normalize as e}from"../../../../node_modules/@adraffy/ens-normalize/dist/index.js";function n(n){return e(n)}export{n as normalize};
